export default {
  required: "%{field} is required ",
  invalid: "%{field} is invalid",
  min: "Minimum %{min} characters",
  max: " Maximum %{max} characters",
  between: "%{filed} should be between %{min} and %{max}",
  character: "Character ",
  sameAs: "%{field} and %{current} are not the same",
  notZero: "%{field} should not be zero.",
  cannotAddPatientInAddUser: "Cannot Add Patient In This Form",
  nationalCode: "The national code format is not correct",
};
